import { render, staticRenderFns } from "./remittanceReports.vue?vue&type=template&id=20d48686&"
import script from "./remittanceReports.vue?vue&type=script&lang=js&"
export * from "./remittanceReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports